import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('cantiere_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        // ─── Session-expired UX (Phase 31) ──────────────────────────────
        // When the backend returns 401 (e.g. JWT expired / missing) on a
        // protected endpoint, wipe the local token and bounce the user to
        // the login screen with a clear message. We deliberately skip the
        // redirect on auth-related endpoints to avoid loops.
        const status = error.response?.status;
        const url = error.config?.url || '';
        const isAuthEndpoint = url.includes('/auth/login') || url.includes('/auth/register') || url.includes('/auth/forgot-password') || url.includes('/auth/reset-password');
        if (status === 401 && !isAuthEndpoint && typeof window !== 'undefined') {
            const hadToken = !!localStorage.getItem('cantiere_token');
            if (hadToken) {
                localStorage.removeItem('cantiere_token');
                const path = window.location.pathname || '';
                const onLogin = path.startsWith('/login') || path.startsWith('/forgot-password') || path.startsWith('/reset-password');
                if (!onLogin) {
                    // Preserve where the user was so we can come back after re-auth.
                    sessionStorage.setItem('cantiereai_return_to', path + (window.location.search || ''));
                    window.location.replace('/login?session=expired');
                }
            }
        }
        return Promise.reject(error);
    }
);
